<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl ? `transaction/class-timetable/${inputs.id}` : `transaction/class-timetable`
				"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_week" class="col-sm-3 mb-0">
						Week
					</label>
					<app-input
						id="inputs_week"
						class="col-sm-9"
						type="text"
						v-model="inputs.week"
						placeholder="CLC Week"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_start_date" class="col-sm-3 mb-0">
						Start Date
					</label>
					<app-input
						id="inputs_start_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.start_date"
						placeholder="Start Date"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_end_date" class="col-sm-3 mb-0">
						End Date
					</label>
					<app-input
						id="inputs_end_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.end_date"
						placeholder="End Date"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_mon" class="col-sm-3 mb-0"> 星期一 </label>
					<app-input
						id="inputs_mon"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_1"
						placeholder="Start Time"
					/>
					<app-input
						id="inputs_mon"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_1"
						placeholder="Finish Time"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_tue" class="col-sm-3 mb-0"> 星期二 </label>
					<app-input
						id="inputs_tue"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_2"
						placeholder="Start Time"
					/>
					<app-input
						id="inputs_tue"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_2"
						placeholder="Finish Time"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_wed" class="col-sm-3 mb-0"> 星期三 </label>
					<app-input
						id="inputs_wed"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_3"
						placeholder="Start Time"
					/>
					<app-input
						id="inputs_wed"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_3"
						placeholder="Finish Time"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_thu" class="col-sm-3 mb-0"> 星期四 </label>
					<app-input
						id="inputs_thu"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_4"
						placeholder="Start Time"
					/>
					<app-input
						id="inputs_thu"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_4"
						placeholder="Finish Time"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_fri" class="col-sm-3 mb-0"> 星期五 </label>
					<app-input
						id="inputs_fri"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_5"
						placeholder="Start Time"
					/>
					<app-input
						id="inputs_fri"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_5"
						placeholder="Finish Time"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_sat" class="col-sm-3 mb-0"> 星期六 </label>
					<app-input
						id="inputs_sat"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_6"
						placeholder="Start Time"
					/>
					<app-input
						id="inputs_sat"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_6"
						placeholder="Finish Time"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_sun" class="col-sm-3 mb-0"> 星期日 </label>
					<app-input
						id="inputs_sun"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_start_7"
						placeholder="Start Time"
					/>
					<app-input
						id="inputs_sun"
						class="col-sm-4"
						type="time"
						v-model="inputs.time_end_7"
						placeholder="Finish Time"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_note" class="col-sm-3 mb-0">
						Note
					</label>
					<app-input
						id="inputs_note"
						class="col-sm-9"
						type="text"
						v-model="inputs.note"
						placeholder="Note"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_last_modified" class="col-sm-3 mb-0">
						Last Modified
					</label>
					<app-input
						id="inputs_last_modified"
						class="col-sm-9"
						type="date"
						v-model="inputs.updated_at"
						placeholder="Last Modified"
						:disabled="true"
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "ClassTimetableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					id: undefined,
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			academyGroupId: null,
			preloader: false,
			inputs: {},
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
		let url = window.location.href;
		this.academyGroupId = parseInt(url.split("/").slice(-1)[0].split("?")[0]);
	},
	methods: {
		submit() {
  			this.inputs.academic_group_id = this.academyGroupId;
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
            $('#'+this.modalId).modal('hide');
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},
	},
};
</script>
